import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 列表查询
export const getList = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/changeRecord`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findChangeRecord'
      }, params))
    }
  })
}


